import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, MainLayoutComponent } from '@meddatacore/common';
import { Page403Component } from './shared/components/page403/page403.component';
import { Page404Component } from './shared/components/page404/page404.component';

const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        component: MainLayoutComponent,
        loadChildren: () => import('./home/home.module').then(d => d.HomeModule)
      },
      {
        path: "queue-back",
        component: MainLayoutComponent,
        loadChildren: () => import('./shared/modules/queue-tenant-admin/queue-tenant-admin.module').then(d => d.QueueTenantAdminModule)
      },
      {
        path: "queue-front",
        component: MainLayoutComponent,
        loadChildren: () => import('./shared/modules/queue-tenant-employee/queue-tenant-employee.module').then(d => d.QueueTenantEmployeeModule)
      },
    ]

  },
  {
    path: 'page403', component: Page403Component
  },
  //Wild Card Route for 404 request
  {
    path: '**', pathMatch: 'full',
    component: Page404Component
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
